module.exports = __webpack_public_path__ + "img/empty.b5bcccc9.png";